import React from 'react';
import logo from './assets/images/sheshipper.png';
import './assets/css/App.css';


//importar componentes
import FormTest from './components/FormTest';
import Som from './components/Som';
import Form from './components/Form';






function App() {
  return (
  <div className="App">
        
          
    <div className="body">
      <div className="divform">
        <div className="AppForm">

              <FormTest/>
        </div>
      </div>
    </div>
    
   
  </div>
      
    
  );
}


export default App; 
